import {
    LABEL_GREY,
    MONTH_ABBREVIATIONS,
    POINT_RADIUS,
    TEXT_VERTICAL_OFFSET,
} from './chart-constants'
import { parseDateString, type DataPoint } from './chart-utils'

interface HorizontalAxisProps {
    columnWidth: number
    data: Record<string | number, DataPoint>
    height: number
    isLineGraph: boolean
    labelType: 'date' | 'number'
    values: (string | number)[]
}

function formatLabel(xVal: string | number, labelType: 'date' | 'number'): string {
    if (labelType === 'date') {
        if (typeof xVal === 'number') {
            // Month number → first letter of month abbreviation
            return MONTH_ABBREVIATIONS[xVal]?.[0] ?? String(xVal)
        }
        // Date string → "MMM" (first 3 chars of month)
        return parseDateString(String(xVal)).toLocaleDateString('en-US', { month: 'short' })
    }
    return String(xVal)
}

export function HorizontalAxis({
    columnWidth,
    data,
    height,
    isLineGraph,
    labelType,
    values,
}: HorizontalAxisProps) {
    return (
        <svg>
            {values.map((key) => {
                const point = data[key]
                if (!point) {
                    return null
                }

                const label = formatLabel(point.xVal, labelType)

                return (
                    <text
                        key={String(point.xVal)}
                        x={
                            isLineGraph
                                ? point.xCoord - POINT_RADIUS
                                : point.xCoord + columnWidth / 4
                        }
                        y={height + TEXT_VERTICAL_OFFSET}
                        fill={LABEL_GREY}
                        fontSize={12}
                    >
                        {label}
                    </text>
                )
            })}
        </svg>
    )
}
